module.exports = __webpack_public_path__ + "img/logo.6e6af66e.svg";